const PSM_BADGES = {
    rc: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/perso/logo-radio-canada-pizza-rouge-archives.jpg',
    cbc: 'https://images.radio-canada.ca/q_auto,w_1200/v1/ici-info/perso/logo-radio-canada-pizza-rouge-archives.jpg',
};

export const getPSMBadgeImageForSilo = (silo: string) => {
    return PSM_BADGES[silo];
};
